import * as React from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '@components/layout';
import api from '@services/api';
import reportError from '@utils/reportError';
import { redirectOnError } from '@utils/helpers';
import { Gallery } from '@definitions/galleries.types';
import { GalleriesView } from '@components/galleriesView';

export const getServerSideProps = async () => {
  try {
    const {
      data: { items: galleries },
    } = await api.get('/galleries/');

    if (!galleries) {
      return { notFound: true };
    }

    return {
      props: { galleries },
    };
  } catch (e) {
    reportError(e);

    return redirectOnError(e);
  }
};

interface SlugProps {
  galleries: Gallery[];
}

const Slug = ({ galleries }: SlugProps) => {
  const intl = useIntl();
  const headerTitle = intl.formatMessage({ id: 'galleries.headerTitle', defaultMessage: 'Contemporary Art Galleries' });
  const headerDescription = intl.formatMessage({
    id: 'galleries.headerDescription',
    defaultMessage:
      'Learn more about the contemporary art galleries PLATFORM partners with for exclusive, limited edition works by leading artists.',
  });

  return (
    <Layout title={headerTitle} defaultDescription={headerDescription}>
      <GalleriesView galleries={galleries} />
    </Layout>
  );
};

export default Slug;
